export function initHeaderFixed() {
    const header = document.querySelector('.header-center') as HTMLElement | null;
    if (!header) return;

    const THRESHOLD = 58;

    const onScroll = () => {
        if (window.pageYOffset > THRESHOLD) {
            header.classList.add('fixed');
        } else {
            header.classList.remove('fixed');
        }
    };

    window.addEventListener('scroll', onScroll, { passive: true });

    // Проверка при загрузке страницы
    onScroll();
}
